import { actions } from "./action-config.js";   
import { createAction } from "./action-creator.js";

export function addAction(actionName, handlers) {   
    actions[actionName] = createAction(actionName, handlers);
}


// TODO: Should be renamed to runActionStep
export async function runActionPhase(actionName, phase, context) {
    const action = actions[actionName];

    // phase = fetch/set/render
    if (!action || typeof action[phase] !== 'function') return;

    // TODO: think about ensuring payload has a property "value" instead of doing this
    const value = context?.value ?? context;
    const data  = context?.data  ?? null;

    // return the result of the action being run, passing in the correct variables
    return action[phase](value, data);
}

// TODO: Finish this function for running all existing steps against an action 
export async function runAction(actionName, phaseOrContext, maybeContext = null) {
    const action = actions[actionName];

    if (!action) return;

    if (typeof phaseOrContext === 'string')
        return runActionPhase(actionName, phaseOrContext, maybeContext);

    const context = phaseOrContext;

    if (!context) return;

    // step = fetch/set/render
    for (const phase in action) {
        if (typeof action[phase] !== 'function') return;        
        const phaseData = await runActionPhase(actionName, phase, context);
        if (phaseData !== undefined)
            context.data = phaseData;
    }
}
